import _ from 'lodash'
import { MutationTree } from 'vuex';
import { BoothApplication, BoothApplicationsState } from '@/store/applications/booths/types';

const mutations: MutationTree<BoothApplicationsState> = {
  gotBoothApplication: (
    state,
    booth: BoothApplication,
  ) => {
    state.applications = _.uniqBy([
      booth,
      ...state.applications,
    ], 'applicationId')
  },
};

export default mutations
